<template>
    <div class="vericode_wrap_">
      <a-input @blur="handleInput" :size="size" aria-placeholder="请输入验证码" placeholder="请输入验证码" v-decorator="[field, {
        rules: [{
          required: true,
          message: '请输入验证码'
        }]
    }]"></a-input>
      <a-button :size="size" @click="handleSendCode" class="mrg_l8_ btn_send_code_" type="primary" ghost>{{count > 0 ? count + 's' : '发送验证码'}}</a-button>
    </div>
</template>
<style lang="scss" scoped>
    .vericode_wrap_ {
        display: flex;
        .mrg_l8_ {
            margin-left: 8px;
        }
        .btn_send_code_ {
            min-width: 102px !important;
            &.ant-btn-lg {
                min-width: auto !important;
            }
        }
    }
</style>
<script>
import api from '@/utils/api'

export default {
    props: {
        size: {
            type: String,
            default: 'default'
        },
        form: {
            type: Object,
            default: () => {}
        },
        field: {
            type: String,
            default: ''
        }
    },
    data () {
        return {
            count: 0
        }
    },
    methods: {
        handleInput (e) {
            console.log('handleInput -> ', e.target.value, e)
            this.$emit('input', e.target.value)
        },
        startCountDown () {
            if (this.count > 0) {
                return
            }
            this.count = 59
            let si = setInterval(() => {
                this.count--
                if (this.count < 1) {
                    clearInterval(si)
                }
            }, 1000);
        },
        handleSendCode () {
            this.startCountDown()
            this.form.validateFields(['loginName'],(err, values) => {
                if (!err) {
                    api.sendSmsCode({
                        phones: values.loginName
                    }).then(res => res.data).then(data => {
                        this.startCountDown()
                    })
                }
            })
        },
    }
}
</script>